export default "__VITE_ASSET__8a7796af__"